<template>
	<b-form @submit.stop.prevent="submitRegister">
		<fieldset :disabled="loading > 0">
			<b-form-group id="login-username-group" label="Username:" label-for="login-username" >
				<b-form-input
					id="login-username"
					v-model="registrationForm.username"
					type="text"
					placeholder="Enter username"
					required
				></b-form-input>
			</b-form-group>
			<b-form-group id="login-email-group" label="Email:" label-for="login-email" >
				<b-form-input
					id="login-email"
					v-model="registrationForm.email"
					type="email"
					placeholder="Enter email"
					required
				></b-form-input>
			</b-form-group>
			<b-form-group id="login-password-group" label="Password:" label-for="login-password">
				<b-form-input
					id="login-password"
					type="password"
					v-model="registrationForm.password"
					placeholder="Enter password"
					required
				></b-form-input>
			</b-form-group>
		</fieldset>

		<b-alert variant="danger" v-show="error" show>{{error}}</b-alert>
		<b-alert variant="success" v-if="message" show>
			{{message}}
			<div class="mt-2" v-if="registeredEmail">
				<b-spinner v-if="resendLoading" small></b-spinner>
				<b-button v-else size="sm" variant="success" @click="resendConfirmation">Resend confirmation email</b-button>
				<div v-if="resendMessage" class="mt-1 small">{{resendMessage}}</div>
				<div v-if="resendError" class="mt-1 text-danger small">{{resendError}}</div>
			</div>
		</b-alert>
		<b-row>
			<b-col cols="8">
				<b-spinner v-show="loading>0" small label="Loading"></b-spinner>
				Already registered? <router-link to="/">Sign in</router-link>
			</b-col>
			<b-col class="text-right" cols="4" v-if="true">
				<b-button variant="success" type="submit" :disabled="loading > 0">Register</b-button>
			</b-col>
		</b-row>
	</b-form>
</template>

<script>
export default {
	data() { return {
		loading: 0,
		error: null,
		message: null,
		plan: null,
		cycle: null,
		registeredEmail: null,
		resendLoading: false,
		resendMessage: null,
		resendError: null,
		registrationForm: {
			username: '',
			email: '',
			password: '',
		},
	}},
	created() {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});

		this.plan = params.plan;
		this.period = params.period;
	},
	async mounted() {
		try {
			this.loading++;
			await this.$recaptcha.getRecaptcha();
		} catch(e) {
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	async beforeDestroy() {
		await this.$recaptcha.cleanup();
	},
	methods: {
		async submitRegister() {
			try {
				this.loading++;
				this.error = this.message = null;
				const result = await this.$api.post('register', {
					...this.registrationForm,
					recaptcha_token: await this.$recaptcha.execute('register'),
				});

				this.$auth.load(result.token);
				this.registeredEmail = this.registrationForm.email;
				this.registrationForm.username = this.registrationForm.password = this.registrationForm.email = '';
				this.message = 'Registration succeeded! Please check your email for the confirmation link.';
			} catch(err) {
				console.error(err);
				this.error = err;
			} finally {
				this.loading--;
			}

			return false;
		},
		async resendConfirmation() {
			this.resendLoading = true;
			this.resendMessage = null;
			this.resendError = null;
			try {
				const result = await this.$api.post('resendConfirmation', { email: this.registeredEmail });
				const next = result.nextAllowedAt ? new Date(result.nextAllowedAt).toLocaleTimeString() : null;
				this.resendMessage = next ? `Email sent! Next resend allowed at ${next}.` : 'Email sent!';
			} catch(err) {
				if(err.code === 'rate_limited') {
					const next = new Date(err.nextAllowedAt).toLocaleTimeString();
					this.resendError = `Please wait until ${next} before requesting another email.`;
				} else if(err.code === 'too_many_attempts') {
					this.resendError = 'Too many resend attempts. Please contact support.';
				} else {
					this.resendError = err.message;
				}
			} finally {
				this.resendLoading = false;
			}
		},
	},
}
</script>
